<template>
    <div class="app-main plan-info-page">
        <el-row type="flex" class="app-main-header" align="middle">
			<el-col :span="14">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
				</div>
			</el-col>
			<el-col :span="10" class="app-main-header-btns">
				<el-button size="small" type="primary" @click="$router.back(-1)">返回 </el-button>
			</el-col>
		</el-row>
        <div class="order-info-main">
            <div class="info-wrap">
                <el-row class="mg-b5">
                    <el-col :span="24">
                        <el-card class="box-card mg-b5" v-if="orderInfo">
							<el-descriptions :column="4" :border="true" :colon="false" size="mini">
								<el-descriptions-item labelClassName="my-descriptions-label" label="入库单号"> {{orderInfo.storeroomOrderCode}} </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="入库日期"> {{orderInfo.storeroomTime}} </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="仓库"> {{orderInfo.storeroomName}} </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="入库状态"> 已入库 </el-descriptions-item>
							</el-descriptions>
						</el-card>
                    </el-col>
                    <el-col :span="24">
                        <el-card class="box-card" style="min-height:calc(100vh - 200px);position: relative;">
                            <el-tabs v-model="activeName">
								<el-tab-pane label="物料列表" name="first">
                                     <div class="materia-table-box order-materia-table-box">
                                         <el-table :data="tableData" v-loading="loading" border size="mini" :header-cell-style="headerCellStyle" :height="'calc(100vh - 240px)'">
                                                <el-table-column prop="lineNumber" label="行号" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="code" label="物料编码" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="name" label="物料名称" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="sspace" label="规格" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="model" label="型号" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="figueNumber" label="图号" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="storeroomNum" label="入库数量" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="unit" label="计量单位" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="xjOrderCode" label="询价单号" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="contractCode" label="合同号" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="remark" label="行备注" :show-overflow-tooltip="true"></el-table-column>
                                         </el-table>
                                     </div>
								</el-tab-pane>
							</el-tabs>
                            <div class="tab-pane-btns">
								<!-- <el-button v-if="activeName == 'first' && orderInfo && orderInfo.state == 2 && checkRole('cgy_role') && !tableEditFlag" size="small" type="primary" @click="updateOrder">编辑</el-button> -->
							</div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    import { getWmsOrderById,getWmsOrderMxList } from '@/api/store/index.js'
    export default {
        components: {

        },
        data() {
            return {
                hId:'',
                activeName:'',
                orderInfo:{
                    state:1,
                    shlxr:'',
                    shcph:'',
                    shphone:'',
                },
                tableData:[],
                loading:'',
            };
        },
        created() {
            let route = this.$route;
            this.hId = route.params.id;  // 详情id
            this.getInfoById();
            this.getTableList();
        },
        mounted() {
            this.activeName = 'first'
        },
        methods: {
            getInfoById(){
                getWmsOrderById({id:this.hId}).then(({data:res})=>{
                    this.orderInfo = res.data || {};
                })
            },
            getTableList(){
                getWmsOrderMxList({
                    page: 1, //当前页码
                    limit: 2000, //当前每页显示的数量
                    objMap: {
                        storeroomOrderId: this.hId,
                    }
                }).then(({data:res})=>{
                    console.log(res)
                    this.tableData = res.data||[];
                    this.tableData.forEach((item,index)=>{
                        item['lineNumber'] = index+1;
                        item['code'] = item.commodity['code'];
                        item['name'] = item.commodity['name'];
                        item['sspace'] = item.commodity['sspace'];
                        item['model'] = item.commodity['model'];
                        item['unit'] = item.commodity['unit'];
                        item['figueNumber'] = item.commodity['figueNumber'];
                    })
                    // this.oldTableData = JSON.stringify(this.tableData);
                })
            },
            getStateText(){

            },
            handerOrder(type){
                if(type == 1){
                    if(this.editHeaderFlag){
                        this.editHeaderFlag = false;
                    }else{
                        this.editHeaderFlag = true;
                    }
                }
            },
            removeRow(row){

            },
            updateOrder(){

            }
        },
        watch: {
            'activeName':function(nVal){

            }
        },
    };
</script>

<style scoped="scoped" lang="scss">
    .order-info-main{
		width: 100%;
		display: flex;
		.info-wrap{
			width: 100%;
		}
	}
	.tab-pane-btns{
		height: 32px;
		position: absolute;
		right: 10px;
    	top: 5px;
		text-align: right;
		.show-tender-row-switch{
			height: 32px;
			line-height: 32px;
			font-size: 14px;
			display: flex;
			.el-switch{
				margin-top: 6px;
			}
			span{
				line-height: 32px;
				margin-right: 10px;
			}
		}
	}
</style>
<style lang="scss">
.plan-info-page{
    .input-head-bar{
        // width: calc(25vh - 90px);
    }
}
.order-materia-table-box{
    .el-table--mini .el-table__cell{
        padding: 2px 0;
    }
    .el-table {
        .cell{
            padding-left: 5px;
            padding-right: 5px;
            .table-edit-input{
                .el-input-group__append{
                    padding: 0 5px;
                }
            }

        }
    }
}
</style>
